import { Button, Modal, ModalProps, Result } from 'antd';
import { HTMLAttributes } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { IoShieldCheckmarkOutline } from 'react-icons/io5';
import { useTheme } from 'styled-components';

export const JobControlledAccessModal: React.FC<
	ModalProps & HTMLAttributes<HTMLDivElement> & { enabled: boolean; onEnable: () => void; onDisable: () => void }
> = ({ enabled, visible, onEnable, onDisable, onCancel }) => {
	const theme = useTheme();

	return (
		<Modal visible={visible} onCancel={onCancel} footer={null}>
			<Result
				icon={
					enabled ? (
						<IoShieldCheckmarkOutline size={90} color={theme.TA_GREEN} />
					) : (
						<AiOutlineInfoCircle size={90} color="rgba(0,0,0,0.4)" />
					)
				}
				title={enabled ? 'Enabled' : 'Disabled'}
				subTitle={
					enabled
						? 'You can now choose who can access each job from the active team members list actions menu'
						: 'This option allows you as a company owner to control access to jobs for your team members'
				}
				extra={
					<Button type={enabled ? 'ghost' : 'primary'} onClick={enabled ? onDisable : onEnable}>
						<p style={{ fontWeight: 600 }}>{enabled ? 'Disable' : 'Enable'}</p>
					</Button>
				}
			/>
		</Modal>
	);
};
